import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import Card from '../components/Card'
import {uncover, voteBack} from '../state/actions/votes'

const Votes = (props) => <div>{props.votes.map((vote, index) =>
  <Card key={`latest-${vote.hiddenId}`}
        index={index}
        uncover={props.uncover}
        voteBack={props.voteBack}
        valentine={vote}
        gameType={props.gameType} />)}</div>

const NoVotes = (props) => <p>Kortelių nėra.</p>

@connect(
  state => ({votes: state.votes.latest}),
  dispatch => bindActionCreators({uncover, voteBack}, dispatch))
export default class LatestVotes extends Component {

  render() {

    const {votes, uncover, voteBack, gameType} = this.props

    return <div className="pal-cards-right">
        {votes.length ? <Votes votes={votes} uncover={uncover} voteBack={voteBack} gameType={gameType} /> : <NoVotes />}
      </div>
  }
}
